<template>
  <CoreDialog
    v-if="isMobile"
    v-model="isOpened"
    :title="$t('Специалист', optionsLang)"
    data-qa="lpu-speciality-list-modal"
    size="fullscreen"
    transition="fade-transition"
    divider
    persistent
    hide-overlay
    no-click-animation
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="handleCloseModal"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>
    <template #default="{ counterXSpaceClass, xSpaceClass }">
      <LpuSpecialityListOptions
        :options="options"
        :class="counterXSpaceClass"
        :x-space-class="xSpaceClass"
        @lpu-select-speciality:select-option="handleClickOption"
      />
    </template>
  </CoreDialog>
  <SideMenu
    v-else
    :value="isOpened"
    :title="$t('Специалист', optionsLang)"
    side-menu-width="650px"
    side-menu-auto-scroll-y
    side-menu-is-block
    use-limit-title
    @side-menu:click-close="handleCloseModal"
  >
    <LpuSpecialityListOptions
      class="py-2"
      :options="options"
      @lpu-select-speciality:select-option="handleClickOption"
    />
  </SideMenu>
</template>

<script>
import { dispatchCustomEventGlobally } from 'www/utils'
import getUserLanguage from 'src/utils/getUserLanguage'
import { SCHEDULE_EVENTS } from 'www/modules/Schedule/constants'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'
import LpuSpecialityListOptions from 'www/vue_components/common/LpuSpecialityList/components/common/LpuSpecialityListOptions.vue'

export default {
  name: 'LpuSpecialityListDialog',
  components: {
    CoreDialog,
    SideMenu,
    LpuSpecialityListOptions,
  },
  data() {
    return {
      isOpened: false,
      isMobile: window.MOBILE_VERSION,
      options: [],
      lpuId: null,
      parent: null,
      optionsLang: { ns: getUserLanguage() },
    }
  },
  mounted() {
    window.addEventListener('lpu-speciality-list:open-dialog', ({
      detail: {
        lpuId,
        target,
        options,
      },
    }) => {
      this.lpuId = lpuId
      this.parent = target
      this.options = options
      this.isOpened = true
    })
  },
  methods: {
    handleCloseModal() {
      this.isOpened = false
    },
    handleClickOption({ option }) {
      dispatchCustomEventGlobally('lpu-speciality-list:select-option', { option, lpuId: this.lpuId })

      dispatchCustomEventGlobally(SCHEDULE_EVENTS.optionClick, {
        option,
        target: this.parent,
        lpuId: this.lpuId,
      })

      this.handleCloseModal()
    },
  },
}
</script>
